/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Direct6Inputs */

const de_job_form_enum_direct6 = /** @type {(inputs: Job_Form_Enum_Direct6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Direkteinstieg`)
};

/** @type {(inputs: Job_Form_Enum_Direct6Inputs) => LocalizedString} */
const en_job_form_enum_direct6 = () => /** @type {LocalizedString} */ ('job_form_enum_DIRECT')

/**

* @param {Job_Form_Enum_Direct6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_direct6 = /** @type {((inputs?: Job_Form_Enum_Direct6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Direct6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_direct6(inputs)
	return en_job_form_enum_direct6(inputs)
});
export { job_form_enum_direct6 as "job_form_enum_DIRECT" }